import { call, take, put } from 'redux-saga/effects';
import { requestHandler } from './fetcher.saga';
import { fetchAll, getMenuSelected } from './login';
import { REFRESH_PROVIDER } from '../constants/synchro';
import { CATEGORY_CHANGES_CANCELLED, PRODUCT_MENU_CHANGES_SAVED, RECEIVE_DAY_CHANGES } from '../constants/dayChanges';

export function* refreshProvider() {
	while (true) {
		yield take(REFRESH_PROVIDER);
		const { result } = yield call(
			requestHandler,
			'synchro',
			'POST',
			true,
			{},
			'/provider'
		);
		if (result && result.result && result.result.success) {
			yield call(fetchAll);
		}
	}
}

export function* refreshDayChanges() {
	while (true) {
		yield take('REFRESH_DAY_CHANGES');
		const id_menu = yield call(getMenuSelected);
		const dayChanges = yield call(
			requestHandler,
			'synchro',
			'GET',
			true,
			null,
			'/dayChanges',
			{
				id_menu,
			}
		);

		yield put({
			type: RECEIVE_DAY_CHANGES,
			data: dayChanges.result.result,
		});
	}
}

// Fins d'enregistrement d'une modification de produits ou de suppléments
// (liaisons catégorie / catégorie de suppléments comprises) : le décompte des
// modifications en cours peut avoir changé.
export const PRODUCT_CHANGES_SAVED = [
	'REQUESTS_UPDATE_PRODUCT_FINISHED',
	'REQUESTS_REWEIGHT_PRODUCT_FINISHED',
	'REQUESTS_CREATE_PRODUCT_FINISHED',
	'REQUESTS_DELETE_PRODUCT_FINISHED',
	'REQUEST_ADD_PRODUCTS_FINISHED',
	'REQUESTS_UPDATE_SUPPLEMENT_FINISHED',
	'REQUESTS_REWEIGHT_SUPPLEMENT_FINISHED',
	'REQUESTS_CREATE_SUPPLEMENT_FINISHED',
	'REQUESTS_DELETE_SUPPLEMENT_FINISHED',
	'REQUESTS_PATCH_SUPPLEMENT_FINISHED',
	// Menus : composition enregistrée (une fois tout envoyé), création,
	// suppression, tri.
	PRODUCT_MENU_CHANGES_SAVED,
	'REQUESTS_CREATE_PRODUCT_MENU_FINISHED',
	'REQUESTS_DELETE_PRODUCT_MENU_FINISHED',
	'REQUESTS_REWEIGHT_PRODUCT_MENU_FINISHED',
];

export function* refreshDayChangesAfterProductSave() {
	while (true) {
		yield take(PRODUCT_CHANGES_SAVED);
		yield put({ type: 'REFRESH_DAY_CHANGES' });
	}
}

// Modification en cours d'une catégorie supprimée : rechargement complet
// (comme après un reset des surcharges). applyDay a pu réinjecter des
// produits ou valeurs venant du siège, pas seulement la grille de la
// catégorie ; fetchAll recharge aussi le décompte des modifications.
export function* reloadAfterCategoryChangesCancelled() {
	while (true) {
		yield take(CATEGORY_CHANGES_CANCELLED);
		yield call(fetchAll);
	}
}

export function* resetOverrides() {
	while (true) {
		const { data } = yield take('RESET_OVERRIDES');
		const id_menu = yield call(getMenuSelected);
		const dayChanges = yield call(
			requestHandler,
			'synchro',
			'POST',
			true,
			{
				id_menu,
				id_zone: window.sessionStorage.getItem('id_zone'),
				...data,
			},
			'/reset-overrides'
		);

		yield call(fetchAll);
	}
}

export function* getOverrides() {
	while (true) {
		const { ids, synchro_type, entity } = yield take('GET_OVERRIDES');
		const id_menu = yield call(getMenuSelected);
		const { result } = yield call(
			requestHandler,
			'synchro',
			'POST',
			true,
			{
				id_menu,
				id_table: ids,
				type: synchro_type,
				id_zone: window.sessionStorage.getItem('id_zone'),
			},
			'/overrides'
		);

		if (result && result.result) {
			const overrides = result.result;
			const overridesByIdTable = overrides.reduce((acc, o) => {
				if (!acc[o.id_table]) acc[o.id_table] = [];
				acc[o.id_table].push(o);
				return acc;
			}, {});
			switch (entity) {
				case 'supplement':
					yield put({
						type: 'PUT_OVERRIDES_SUPPLEMENT',
						overrides: overridesByIdTable,
					});
					break;
				case 'productMenu':
					yield put({
						type: 'PUT_OVERRIDES_PRODUCT_MENU',
						overrides: overridesByIdTable,
					});
					break;
			}
		}
	}
}
